export default "__VITE_ASSET__PykVgY20__"